/**
 * Reads UTM parameters from the current page URL and appends them
 * (along with an sck tracking parameter) to a Hotmart checkout URL.
 */

function getUtmParams(): Record<string, string> {
  const params = new URLSearchParams(window.location.search)
  return {
    utm_source: params.get('utm_source') || 'none',
    utm_medium: params.get('utm_medium') || 'none',
    utm_campaign: params.get('utm_campaign') || 'none',
    utm_content: params.get('utm_content') || 'none',
    utm_term: params.get('utm_term') || 'none',
  }
}

/**
 * Takes a base Hotmart URL and appends UTM parameters + sck tracking.
 * The sck parameter contains all UTM values separated by |
 */
export function buildHotmartUrl(baseUrl: string): string {
  const utms = getUtmParams()
  const url = new URL(baseUrl)

  // Append each UTM parameter
  url.searchParams.set('utm_source', utms.utm_source)
  url.searchParams.set('utm_medium', utms.utm_medium)
  url.searchParams.set('utm_campaign', utms.utm_campaign)
  url.searchParams.set('utm_content', utms.utm_content)
  url.searchParams.set('utm_term', utms.utm_term)

  // Build sck: all UTM values separated by |
  const sck = [
    utms.utm_source,
    utms.utm_medium,
    utms.utm_campaign,
    utms.utm_content,
    utms.utm_term,
  ].join('|')
  url.searchParams.set('sck', sck)

  return url.toString()
}
